import "@hotwired/turbo-rails";
import { Application } from "@hotwired/stimulus"

import ModalController from "../shared/modal_controller"
import DropdownController from "../shared/dropdown_controller"
import ToggleController from "../shared/toggle_controller"
import TooltipController from "../shared/tooltip_controller"
import NavigationController from "../shared/navigation_controller"
import TabsController from "../shared/tabs_controller"
import LazyLoadToggleController from "../shared/lazy_load_toggle_controller"
import MapController from "../shared/map_controller"
import CustomAutocompleteController from "../shared/custom_autocomplete_controller"
import FindMechanicsSearchController from "../shared/find_mechanics_search_controller"
import StarRatingController from "./star_rating_controller"
import OfferCardController from "./offer_card_controller"
import RangeSliderController from "./range_slider_controller"
import LegacyModalController from "./legacy_modal_controller"
import AutoFormSubmitController from "../shared/auto_form_submit_controller"
import BookingPreferencesDateTimeController from "./booking_preferences_date_time_controller"
import BookingJourneyUpsellController from "./booking_journey_upsell_controller"
import SlideshowController from "./slideshow_controller"
import ReviewFlowFormRatingController from "./review_flow_form_rating_controller"
import ReviewsController from "./reviews_controller"
import AutobidPollController from "./autobid_poll_controller"
import LoadingSpinnerController from "./loading_spinner_controller"
import CountdownController from "../shared/countdown_controller"
import InteractionsController from "./interactions_controller"
import MyGarageCarFormController from "./my_garage_car_form_controller"
import SidebarController from "./sidebar_controller"
import PopperController from "../shared/popper_controller"
import CarOwnerFieldController from "../shared/car_owner_field_controller"
import DawaLookupController from "../shared/dawa_lookup_controller"
import AutoSubmitPermissionsController from "./auto_submit_permissions_controller"
import CarOwnersNotificationsController from "./car_owners_notifications_controller"
import DisableCheckboxesController from "./disable_checkboxes_controller"
import MakesAndModelsController from "./makes_and_models_controller"
import CarFormController from "./car_form_controller"
import ExternalPartnersDinitrolBookingController from "./external_partners/dinitrol/booking_controller"

import './icons';

import "../../misc/address_lookup"
import '../../misc/datepickers';
import '../../misc/gtm_data_layer';
import '../../misc/tracking';

require('rails-ujs').start();

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

application.register("modal", ModalController)
application.register("dropdown", DropdownController)
application.register("toggle", ToggleController)
application.register("tooltip", TooltipController)
application.register("navigation", NavigationController)
application.register("tabs", TabsController)
application.register("lazy-load-toggle", LazyLoadToggleController)
application.register("map", MapController)
application.register("custom-autocomplete", CustomAutocompleteController)
application.register("find-mechanics-search", FindMechanicsSearchController)
application.register("star-rating", StarRatingController)
application.register("offer-card", OfferCardController)
application.register("range-slider", RangeSliderController)
application.register("legacy-modal", LegacyModalController)
application.register("auto-form-submit", AutoFormSubmitController)
application.register("booking-preferences-date-time", BookingPreferencesDateTimeController)
application.register("booking-journey-upsell", BookingJourneyUpsellController)
application.register("slideshow", SlideshowController)
application.register("review-flow-form-rating", ReviewFlowFormRatingController)
application.register("reviews", ReviewsController)
application.register("autobid-poll", AutobidPollController)
application.register("loading-spinner", LoadingSpinnerController)
application.register("countdown", CountdownController)
application.register("interactions", InteractionsController)
application.register("my-garage-car-form", MyGarageCarFormController)
application.register("sidebar", SidebarController)
application.register("popper", PopperController)
application.register("car-owner-field", CarOwnerFieldController)
application.register("dawa-lookup", DawaLookupController)
application.register("auto-submit-permissions", AutoSubmitPermissionsController)
application.register("car-owners-notifications", CarOwnersNotificationsController)
application.register("disable-checkboxes", DisableCheckboxesController)
application.register("makes-and-models", MakesAndModelsController)
application.register("car-form", CarFormController)
application.register("external-partners-dinitrol-booking", ExternalPartnersDinitrolBookingController)
